import { Controller } from "@hotwired/stimulus"

const ROW_SELECTOR = "[data-product-grid-target='row']"

export default class extends Controller {
  static targets = ["body", "row", "rowTemplate", "lotTemplate", "count", "submit", "confirmation"]
  static values = { countOne: String, countOther: String, confirmLabel: String }

  connect() {
    this.renumber()
    this.refreshCount()
  }

  addRow(event) {
    event?.preventDefault()
    const previous = this.rowTargets[this.rowTargets.length - 1]
    const index = this.uniqueIndex()
    this.bodyTarget.insertAdjacentHTML("beforeend", this.rowTemplateTarget.innerHTML.replace(/NEW_ROW/g, index))
    const row = this.rowTargets[this.rowTargets.length - 1]
    if (previous) this.copySelects(previous, row)
    this.renumber()
    row.querySelector("[data-field='name']").focus()
  }

  keydown(event) {
    if (event.key !== "Enter" || event.target.matches("button, [type=submit]")) return
    event.preventDefault()
    const row = event.target.closest(ROW_SELECTOR)
    if (!row) return
    const next = this.rowTargets[this.rowTargets.indexOf(row) + 1]
    if (next) return next.querySelector("[data-field='name']").focus()
    if (!row.querySelector("[data-field='name']").value.trim()) return
    this.addRow()
  }

  kindChanged(event) {
    const select = event.target
    const finished = select.value === "finished_good"
    select.classList.toggle("is-finished", finished)
    select.classList.toggle("is-raw", !finished)
    this.applyLotLabels(select.closest(ROW_SELECTOR))
  }

  toggleLots(event) {
    const row = event.target.closest(ROW_SELECTOR)
    const tracking = event.target.checked
    row.querySelector("[data-field='initial_quantity']").hidden = tracking
    row.querySelectorAll("[data-lot-row], [data-lot-add]").forEach(element => { element.hidden = !tracking })
    if (tracking && !row.querySelector("[data-lot-row]")) this.appendLot(row)
    this.refreshCount()
  }

  addLot(event) {
    event.preventDefault()
    this.appendLot(event.target.closest(ROW_SELECTOR))
  }

  removeLot(event) {
    event.preventDefault()
    event.target.closest("[data-lot-row]").remove()
  }

  removeRow(event) {
    event.preventDefault()
    event.target.closest(ROW_SELECTOR).remove()
    if (this.rowTargets.length === 0) this.addRow()
    this.renumber()
    this.refreshCount()
  }

  refreshCount() {
    const filled = this.rowTargets.filter(row => row.querySelector("[data-field='name']").value.trim()).length
    const label = filled === 1 ? this.countOneValue : this.countOtherValue
    this.countTarget.textContent = this.pendingConfirmation() ? this.confirmLabelValue : label.replace("%{count}", filled)
    this.submitTarget.disabled = filled === 0
  }

  pendingConfirmation() {
    return this.confirmLabelValue !== "" && this.hasConfirmationTarget
  }

  appendLot(row) {
    const html = this.lotTemplateTarget.innerHTML
      .replace(/NEW_ROW/g, row.dataset.rowIndex)
      .replace(/NEW_LOT/g, this.uniqueIndex())
    row.querySelector("[data-lot-add]").insertAdjacentHTML("beforebegin", html)
    this.applyLotLabels(row)
    const lots = row.querySelectorAll("[data-lot-row]")
    lots[lots.length - 1].querySelector("[data-field='lot_code']").focus()
  }

  applyLotLabels(row) {
    const finished = row.querySelector("[data-field='kind']").value === "finished_good"
    row.querySelectorAll("[data-lot-label]").forEach(input => {
      input.placeholder = finished ? input.dataset.finishedLabel : input.dataset.rawLabel
    })
  }

  copySelects(from, to) {
    ["kind", "stock_unit"].forEach(field => {
      const target = to.querySelector(`[data-field='${field}']`)
      target.value = from.querySelector(`[data-field='${field}']`).value
      target.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }

  renumber() {
    this.rowTargets.forEach((row, position) => {
      const cell = row.querySelector("[data-row-number]")
      if (cell) cell.textContent = position + 1
    })
  }

  uniqueIndex() {
    this.sequence = (this.sequence || 0) + 1
    return `${Date.now()}${this.sequence}`
  }
}
